export default __webpack_public_path__ + "img/accha/accha1_480.jpg";